module.exports = __webpack_public_path__ + "img/Banner_1.ff2a3d2c.svg";